import { COMPANY } from "../../data/company";

// What a report of a fake brand needs, so the team can check it without writing back for details.
export const FAKE_BRAND_REASONS = [
  { id: "copycat", label: "Pretends to be another brand or copies a real one" },
  { id: "no-delivery", label: "Takes payment but does not deliver" },
  { id: "counterfeit", label: "Products are counterfeit or do not match the photos" },
  { id: "fake-reviews", label: "Fake reviews or fake endorsements" },
  { id: "fake-details", label: "Company details look made up or cannot be found" },
  { id: "fake-badge", label: "Claims a Rivyou badge or verification it does not have" },
  { id: "other", label: "Something else" },
];

export const FOUND_VIA = [
  "Instagram or Facebook ad",
  "Instagram or Facebook page",
  "WhatsApp or Telegram message",
  "Google search",
  "A marketplace listing",
  "A friend or family member",
  "Somewhere else",
];

export const MONEY_OPTIONS = [
  { id: "no", label: "No, I have not ordered" },
  { id: "nothing", label: "I paid and got nothing" },
  { id: "wrong-item", label: "I paid and got a wrong or fake item" },
];

const reasonLabel = (id) => FAKE_BRAND_REASONS.find((reason) => reason.id === id)?.label || id;
const moneyLabel = (id) => MONEY_OPTIONS.find((option) => option.id === id)?.label || "Not stated";

/** Checks a report and returns an object of field errors (empty when it is complete). */
export function validateFakeBrandReport(report) {
  const errors = {};
  if (!report.brandName?.trim()) errors.brandName = "Tell us the brand name.";
  if (!report.link?.trim()) errors.link = "Add the website, store or social page link.";
  if (!report.foundVia) errors.foundVia = "Tell us where you came across it.";
  if (!report.reasons?.length) errors.reasons = "Pick at least one reason.";
  if ((report.details || "").trim().length < 20)
    errors.details = "Describe what happened in a sentence or two (at least 20 characters).";
  if (!report.confirmed) errors.confirmed = "Please confirm the report is accurate.";
  return errors;
}

/** The subject and body of the email that carries the report to the team. */
export function buildFakeBrandReport(report) {
  const lines = [
    `Brand name: ${report.brandName.trim()}`,
    `Website, store or social link: ${report.link.trim()}`,
    `Where I came across it: ${report.foundVia}`,
    "",
    "Why I think it is fake:",
    ...report.reasons.map((id) => `- ${reasonLabel(id)}`),
    "",
    "What happened:",
    report.details.trim(),
    "",
    `Did I order or pay? ${moneyLabel(report.money)}`,
    `Evidence (links to screenshots, ads, payment or order proof): ${report.evidence?.trim() || "None added. I will attach files to this email."}`,
    `Reported by: ${report.name?.trim() || "Not given"}`,
    "",
    "I confirm this report is accurate to the best of my knowledge.",
  ];
  return {
    subject: `Report a fake brand: ${report.brandName.trim()}`,
    body: lines.join("\n"),
  };
}

/**
 * Sends a fake-brand report. There is no reports endpoint on the server yet, so this opens an email to the team with the whole report filled in.
 * When an endpoint exists, change only this function; the form and the report shape stay the same.
 */
export function submitFakeBrandReport(report) {
  const { subject, body } = buildFakeBrandReport(report);
  const mailto = `mailto:${COMPANY.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailto;
  return { success: true, channel: "email", mailto };
}

// ---- Wrong fact reports ----

export const WRONG_FACT_AREAS = [
  "Company name or registration",
  "Incorporation date or domain age",
  "Certificates or licences",
  "Delivery performance",
  "Payment success",
  "Returns or refund policy",
  "COD availability or charges",
  "Reviews or ratings",
  "Contact details or address",
  "Something else",
];

export const WRONG_FACT_ROLES = [
  { id: "shopper", label: "I am a shopper" },
  { id: "owner", label: "I run this brand" },
  { id: "other", label: "Someone else" },
];
